export enum ModelEnum {
    TASK = "TaskModel",
    PROJECT = "ProjectModel",
    USER = "UserModel"
}